import { Injectable } from '@angular/core';

import { BeneficiariesValueModel, PreFilledProperty } from '../Models/pre-filled-property.interface';
import { isNotNullOrUndefinedOrEmpty } from '../objectUtils';
import { BeneficiaryItem } from '@infrastructure/Models/beneficiary-item';
import { PersonType,PersonTypeString } from '@infrastructure/Models/const.personType';

@Injectable({ providedIn: "root" })

export class BeneficiaryValuesService {


  private arrayOfBeneficiaries: BeneficiariesValueModel[] = [];

  public getBeneficiaryValues(beneficiaryId: number): BeneficiariesValueModel {
    const existe = this.arrayOfBeneficiaries.find(el => el.beneficiaryId === beneficiaryId);
    return existe;
  }

  public setBeneficiaryValues(beneficiary: models.BeneficiaryListVM): void {

    // verifica se já existe no array interno?
    const existeElemento = this.arrayOfBeneficiaries.find(el => el.beneficiaryId == beneficiary.beneficiaryID);
    if (existeElemento === null || existeElemento === undefined) {
      //se não existe adiciona
      const newElement: BeneficiariesValueModel = {
        beneficiaryId: beneficiary.beneficiaryID,
        values: [
          {
            name: 'mobileNumber',
            preFilledValue: beneficiary.mobileNumber,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.mobileNumber)
          },
          {
            name: 'email',
            preFilledValue: beneficiary.email,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.email)
          },
          {
            name: 'countryCode',
            preFilledValue: beneficiary.countryCode,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.countryCode)
          },
          {
            name: 'address',
            preFilledValue: beneficiary.address,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.address)
          },
          {
            name: 'postalCodeFirst',
            preFilledValue: beneficiary.postalCodeFirst,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.postalCodeFirst)
          },
          {
            name: 'postalCodeLast',
            preFilledValue: beneficiary.postalCodeLast,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.postalCodeLast)
          },
          {
            name: 'postalCodeFull',
            preFilledValue: beneficiary.postalCodeFull,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.postalCodeFull)
          },
          {
            name: 'locality',
            preFilledValue: beneficiary.locality,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.locality)
          },
          {
            name: 'beneficiaryName',
            preFilledValue: beneficiary.beneficiaryName,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.beneficiaryName)
          },
          {
            name: 'dateOfBirth',
            preFilledValue: beneficiary.dateOfBirth,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.dateOfBirth)
          },
          {
            name: 'hasNacPT',
            preFilledValue: beneficiary.hasNacPT,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.hasNacPT)
          },
          {
            name: 'hasNIFPT',
            preFilledValue: beneficiary.hasNIFPT,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.hasNIFPT)
          },
          {
            name: 'NIF',
            preFilledValue: beneficiary.NIF,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.NIF)
          },
          {
            name: 'financialService',
            preFilledValue: beneficiary.financialService,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.financialService)
          },
          {
            name: 'identificationNumberFirst',
            preFilledValue: beneficiary.identificationNumberFirst,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.identificationNumberFirst)
          },
          {
            name: 'identificationNumberLast',
            preFilledValue: beneficiary.identificationNumberLast,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.identificationNumberLast)
          },
          {
            name: 'gender',
            preFilledValue: beneficiary.gender,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.gender)
          },
          {
            name: 'NISS',
            preFilledValue: beneficiary.NISS,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.NISS)
          },
          {
            name: 'identificationDocumentType',
            preFilledValue: beneficiary.identificationDocumentType,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.identificationDocumentType)
          },
          {
            name: 'finantialServiceFirst',
            preFilledValue: beneficiary.locality,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.locality)
          },
          {
            name: 'civilStateDeathDate',
            preFilledValue: beneficiary.locality,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.locality)
          },
          {
            name: 'nationality',
            preFilledValue: beneficiary.nationality,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.nationality)
          },
          {
            name: 'emailNotification',
            preFilledValue: beneficiary.emailNotification,
            hasValue: isNotNullOrUndefinedOrEmpty(beneficiary.emailNotification)
          }
        ]
      };
      this.arrayOfBeneficiaries.push(newElement);
    }
   
  }


  public getPreFilledProperties(
    beneficiaryID: number,
    cardData: any,
    fieldArray: string[]): PreFilledProperty[] {


    const result: PreFilledProperty[] = [];
    const beneficiaryOnInstance = this.getBeneficiaryValues(beneficiaryID);

    fieldArray.forEach(property => {
      // trazer a propriedade no array interno de beneficiario
      if (beneficiaryOnInstance != undefined && beneficiaryOnInstance == null) {
        const propertyOnInstance = beneficiaryOnInstance.values.find(el => el.name == property);;
        // Adicionar uma PreFilledProperty ao result que vai ser retornado
        result.push(
          {
            name: property,
            preFilledValue: cardData[property],
            hasValue: isNotNullOrUndefinedOrEmpty(cardData[property]) && propertyOnInstance.hasValue
          }
        );
      } else {
        result.push(
          {
            name: property,
            preFilledValue: cardData[property],
            hasValue: isNotNullOrUndefinedOrEmpty(cardData[property])
          }
        );
      }
    });

    return result;

  }

  public buildBeneficiariesItemList(
    beneficiaryList: models.BeneficiaryListVM[],
    deceasedIdentification: models.DeceasedIdentificationVM,
    senderIdentification: models.SenderIdentificationVM,
    documentsList: models.DocumentVM_PM[]): BeneficiaryItem[] {
    const result = beneficiaryList
      .map(el => {
        const newBeneficiary: BeneficiaryItem = {
          value: el.beneficiaryID,
          description: el.beneficiaryName,
          name: el.beneficiaryName,
          type: PersonTypeString.Beneficiary // "Beneficiary"
        };
        return newBeneficiary;
      });

    // Add the deceased to the list

    const deceased: BeneficiaryItem = {
      value: PersonType.Deceased,
      description: deceasedIdentification.subscriberName,
      name: deceasedIdentification.subscriberName,
      type: PersonTypeString.Deceased //  "Deceased"
    };
    result.push(deceased);

    //Add sender if not on the list
  
    const existeOnListDoc = documentsList.filter(el => el.ownerName == senderIdentification.name &&
      el.beneficiaryID == PersonType.Sender).length > 0;
    const existeOnListBeneficiaries = result.filter(el => el.name == senderIdentification.name &&
      el.value == PersonType.Sender).length > 0;

    if (!existeOnListDoc || !existeOnListBeneficiaries) {
      const sender: BeneficiaryItem = {
        value: PersonType.Sender,
        description: senderIdentification.name + " - Remetente",
        name: senderIdentification.name,
        type: PersonTypeString.Sender // "Sender"
      };
      result.push(sender);

    }

    return result;
  }

}
